/**
 * LocalStorage設定関数
 * 基本的に永続のLocalStorageにデータを保存
 * @function setCookie
 * @param {String} key キー名
 * @param {String} value 値
 * @param {String} type 型　string/int/array
 * @return {Any} 指定した型のデータ　データが無い場合は''/0/[]
 * Use
import getLocalStorage from './functions/_localStorage-getLocalStorage.js' // LocalStorageを取得
// const hogeString = getLocalStorage('hogeString', 'string') // LocalStorageを取得
// const hogeInt = getLocalStorage('hogeInt', 'int') // LocalStorageを取得
// const hogeArray = getLocalStorage('hogeArray', 'array') // LocalStorageを取得
 */
const getLocalStorage = (key, type = 'string') => {
  let value = localStorage.getItem(key) // localStorageからデータを取得
  if (type === 'string') {
    value = value ? value : '' // 文字列を補正
    return value
  }
  if (type === 'array') {
    value = value ? JSON.parse(value) : [] // JSONを配列に変換
    return value
  }
  if (type === 'int') {
    value = value ? parseInt(value, 10) : 0 // 整数に変換
    return value
  }
}

export default getLocalStorage
